import React, {useRef, useEffect } from 'react'
import {TweenMax, TimelineLite, Power3} from 'gsap';
import Styles from '../sass/layout/Hero.module.sass'
import hero from '../images/2.jpg'

function Hero() {

  let app = useRef(null);
  let images = useRef(null);
  let content = useRef(null);
  let tl = new TimelineLite();


    useEffect(() => {

      // variable for hero content 
      const headlineFirst = content.children[0].children[0];
      const headlineSecond = headlineFirst.nextSibling;
      const headlineThird = headlineSecond.nextSibling;
      const headlineFourth = headlineThird.nextSibling;

      TweenMax.to(app, 0, {css: {visibility: 'visible'}})

      tl.from(images, 1.5, {y: 500, ease: Power3.easeOut}, 'Start')
        .from(images.firstElementChild, 2, {scale: 1.6, ease: Power3.easeOut}, 0.5)

      // content animation 
      tl.staggerFrom([headlineFirst.children, headlineSecond.children, headlineThird.children, headlineFourth.children], 1, {
        y: 120,
        ease: Power3.easeOut,
        delay: .8
      }, .15, 'Start')
    })

  return (
    <div className={Styles.hero} ref={el => app = el}>
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className={Styles.hero__content} ref={el => content = el}>
              <h2 className={Styles.hero__title}>
                <div className={Styles.hero__title__line}>
                  <div className={Styles.hero__title__line__inner}>I'm a</div>
                </div> 
                <div className={Styles.hero__title__line}>
                  <div className={Styles.hero__title__line__inner}>awesome</div>
                </div> 
                <div className={Styles.hero__title__line}>
                  <div className={Styles.hero__title__line__inner}><span>website</span></div>
                </div>
                <div className={Styles.hero__title__line}>
                  <div className={Styles.hero__title__line__inner}><span>creator</span></div>
                </div>
              </h2>
            </div>
          </div>
          <div className="col-lg-6">
            <div className={Styles.hero__thumb} ref={el => images = el}>
              <img src={hero} alt="hero" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}


export default Hero